export interface DireccionTrabajador {
  idDireccion: number;
  idTrabajador: number;
  tipoDireccion: string;
  tipoVia: string | null;
  nombreVia: string | null;
  numeroVia: string | null;
  interior: string | null;
  departamento: string | null;
  manzana: string | null;
  lote: string | null;
  kilometro: string | null;
  tipoZona: string | null;
  nombreZona: string | null;
  referencia: string | null;
  ubigeo: string | null;
  departamentoGeo: string | null;
  provinciaGeo: string | null;
  distritoGeo: string | null;
  codigoPais: string;
  activo: boolean;
}

export const initialDireccion: DireccionTrabajador = {
  idDireccion: 0,
  idTrabajador: 0,
  tipoDireccion: 'DOMICILIO',
  tipoVia: null,
  nombreVia: null,
  numeroVia: null,
  interior: null,
  departamento: null,
  manzana: null,
  lote: null,
  kilometro: null,
  tipoZona: null,
  nombreZona: null,
  referencia: null,
  ubigeo: null,
  departamentoGeo: null,
  provinciaGeo: null,
  distritoGeo: null,
  codigoPais: '604',
  activo: true,
};

export const TIPOS_VIA = ['AV.', 'CA.', 'JR.', 'PSJE.', 'PROL.', 'CTRA.', 'MALECON', 'OVALO', 'PZA.'];
export const TIPOS_ZONA = ['URB.', 'AA.HH.', 'COOP.', 'RES.', 'P.J.', 'ASOC.', 'OTROS'];
